import React from 'react';
import RemarksMain from './remarks/remarks-main';

function RemarksDetails() {
  return (
    <div className="main-content">
      <RemarksMain/>
    </div>
  );
}

export default RemarksDetails;
